import React, { useRef } from 'react';
import './WIFI_Icon.scss';

// 測試用
// import { WIFI_icon } from './../admin/Index/MainPage'; // WIFI-icon

const Radar = React.memo((props) => {

    const wifiGroup = useRef(null);
    const wifiItem = useRef(null);

    return (
        <>
            <div className={`wifi-group ${props.style==="scan"?"model_radar_blue":"model_radar_gray"} pos-a
            ${props.size !== null || props.size !== undefined ? props.size : ""}
            ${props.rssi === null || props.rssi === undefined
                    ? "rssi_none"
                    : props.rssi > -50
                        ? "rssi_exc"
                        : props.rssi > -60
                            ? "rssi_good"
                            : props.rssi > -70
                                ? "rssi_fair"
                                : props.rssi <= -70
                                    ? "rssi_weak"
                                    : ""

                }`}
                ref={wifiGroup}
            >
                {/* Wifi 最外層 */}
                <div className={`wifi-item wifi-item2 ${props.rssi > -50
                    ? "active"
                    : ""
                    }`}
                    ref={wifiItem}>
                    <div className={`wifi-item wifi-item2 ${props.rssi > -60
                        ? "active"
                        : ""
                        }`}>
                        <div className={`wifi-item wifi-item3 ${props.rssi > -70
                            ? "active"
                            : ""
                            }`}>
                            {/* Wifi 最內層 */}
                            <div className={`wifi-item wifi-item4 
                            ${props.rssi !== null && props.rssi !== undefined && props.rssi > -100
                                    ? "active"
                                    : ""
                                }`}></div>
                        </div>
                    </div>
                </div>

                {/* Wifi sign */}
                <div className={`wifi_sign 
                ${props.rssi !== null && props.rssi !== undefined && props.rssi > -100
                        ? ""
                        : "rssi_none"
                    }`}></div>

            </div>

        </>
    )
})

export default Radar;